import styled from "styled-components";

export const LoadingWrapper = styled.div`
  display: inline-block;
  position: absolute;
  text-align: center;
  vertical-align: middle;
  top: calc(50vh - 100px);
  left: calc(50vw - 90px);
`;
